import type { HugeiconsProps } from '@hugeicons/react-native';
import {
  BirthdayCakeIcon as BirthdayCakeSolidIcon,
  EyeIcon as EyeSolidIcon,
  Location01Icon as Location01SolidIcon,
  Orbit01Icon as Orbit01SolidIcon,
  Search02Icon as Search02SolidIcon,
  SparklesIcon as SparklesSolidIcon,
  StarIcon as StarSolidIcon,
  UserCircleIcon as UserCircleSolidIcon,
} from '@hugeicons-pro/core-solid-rounded';
import {
  BirthdayCakeIcon,
  EyeIcon,
  Location01Icon,
  Orbit01Icon,
  Search02Icon,
  SparklesIcon,
  StarIcon,
  UserCircleIcon,
} from '@hugeicons-pro/core-stroke-rounded';
import type { TFunction } from 'i18next';

import { peopleListTypes, type PeopleListType } from '~/constants/lists';

export interface IPeopleListItem {
  value: PeopleListType;
  label: string;
  icon: HugeiconsProps['icon'];
  solidIcon: HugeiconsProps['icon'];
  href: string;
  separatorBefore?: boolean;
  sectionTitleBefore?: string;
}

const peopleIcons: Record<PeopleListType, [HugeiconsProps['icon'], HugeiconsProps['icon']]> = {
  online: [UserCircleIcon, UserCircleSolidIcon],
  nearby: [Location01Icon, Location01SolidIcon],
  following: [StarIcon, StarSolidIcon],
  followers: [Orbit01Icon, Orbit01SolidIcon],
  visitors: [EyeIcon, EyeSolidIcon],
  new: [SparklesIcon, SparklesSolidIcon],
  birthdays: [BirthdayCakeIcon, BirthdayCakeSolidIcon],
  search: [Search02Icon, Search02SolidIcon],
};

export function getPeopleListHref(listType: PeopleListType): string {
  if (listType === 'nearby') {
    return '/people/nearby/recent';
  }

  if (listType === 'search') {
    return '/people/search';
  }

  return `/people/${listType}`;
}

export function getPeopleListTypeFromPathname(pathname?: string | null): PeopleListType | null {
  if (!pathname?.startsWith('/people')) {
    return null;
  }

  const matchedType = peopleListTypes.find((listType) =>
    pathname.startsWith(`/people/${listType}`)
  );
  return matchedType ?? 'online';
}

export function getPeopleListItems(t: TFunction): IPeopleListItem[] {
  return peopleListTypes.map((listType, index) => {
    const [icon, solidIcon] = peopleIcons[listType];

    return {
      value: listType,
      label: t(`people.${listType}_short`),
      icon,
      solidIcon,
      href: getPeopleListHref(listType),
      separatorBefore: listType === 'search',
      sectionTitleBefore: index === 0 ? t('navigation.people') : undefined,
    };
  });
}
